module.exports = __webpack_public_path__ + "img/[悠闲].cf3c5109.svg";